import { DailySummaryDataActionTypes } from "../constants/ApiConstants";

const initialState = {
    loading: false,
    masterData: [],
    dailySummaryDataDomainList : null,
    dailySummaryDataProgramList : null,
    dailySummaryDataTargetList : null,
    behaviorList : null,
    getDailySummaryData : null,
    getDailySummaryBehaviorData : null,
    updateDailySummarySkillAcquisitionData : null,
    updateDailySummaryBehaviorData:null
}

export default (state = initialState, { type, payload }) => {
    switch(type){
    case DailySummaryDataActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case DailySummaryDataActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case DailySummaryDataActionTypes.get_DailySummaryDomainList.REQUEST:
      return {
        ...state,
        loading: true,
        dailySummaryDataDomainList: null,
      };
    case DailySummaryDataActionTypes.get_DailySummaryDomainList.SUCCESS:
      return {
        ...state,
        loading: false,
        dailySummaryDataDomainList: payload,
      };
    case DailySummaryDataActionTypes.get_DailySummaryProgramList.REQUEST:
      return {
        ...state,
        loading: true,
        dailySummaryDataProgramList: null,
      };
    case DailySummaryDataActionTypes.get_DailySummaryProgramList.SUCCESS:
      return {
        ...state,
        loading: false,
        dailySummaryDataProgramList: payload,
      };
    case DailySummaryDataActionTypes.get_DailySummaryTargetList.REQUEST:
      return {
        ...state,
        loading: true,
        dailySummaryDataTargetList: null,
      };
    case DailySummaryDataActionTypes.get_DailySummaryTargetList.SUCCESS:
      return {
        ...state,
        loading: false,
        dailySummaryDataTargetList: payload,
      };
      case DailySummaryDataActionTypes.get_behaviorList.REQUEST:
        return {
          ...state,
          loading: true,
          behaviorList: null,
        };
      case DailySummaryDataActionTypes.get_behaviorList.SUCCESS:
        return {
          ...state,
          loading: false,
          behaviorList: payload,
        };
      case DailySummaryDataActionTypes.get_DailySummaryData.REQUEST:
        return {
          ...state,
          loading: true,
          getDailySummaryData: null,
        };
      case DailySummaryDataActionTypes.get_DailySummaryData.SUCCESS:
        return {
          ...state,
          loading: false,
          getDailySummaryData: payload,
        };
      case DailySummaryDataActionTypes.get_DailySummaryBehaviorData.REQUEST:
        return {
          ...state,
          loading: true,
          getDailySummaryBehaviorData: null,
        };
      case DailySummaryDataActionTypes.get_DailySummaryBehaviorData.SUCCESS:
        return {
          ...state,
          loading: false,
          getDailySummaryBehaviorData: payload,
        };
      case DailySummaryDataActionTypes.update_DailySummarySkillAcquisitionData.REQUEST:
        return {
          ...state,
          loading: true,
          updateDailySummarySkillAcquisitionData: null,
        };
      case DailySummaryDataActionTypes.update_DailySummarySkillAcquisitionData.SUCCESS:
        return {
          ...state,
          loading: false,
          updateDailySummarySkillAcquisitionData: payload,
        };
        case DailySummaryDataActionTypes.update_DailySummaryBehaviorData.REQUEST:
        return {
          ...state,
          loading: true,
          updateDailySummaryBehaviorData: null,
        };
      case DailySummaryDataActionTypes.update_DailySummaryBehaviorData.SUCCESS:
        return {
          ...state,
          loading: false,
          updateDailySummaryBehaviorData: payload,
        };
      default:
       return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/DailySummaryData/reducers/DailySummaryReducers.js